import { apiBaseUrl, scApiBaseUrl } from 'yxt-biz-pc/packages/api';

// 外训详情
export const TrainingInfo = applyId => {
  return apiBaseUrl.post(
    `/mix2/ds/train/apply/train/info?process=false&applyId=${applyId}`
  );
};
// 获取计划申请表下载链接
export const getDownloadExcelUrl = id => {
  return scApiBaseUrl.get(`/file/download/saveas?fileId=${id}`);
};
